﻿import Api from '../../../../../shared/Api';
import { Photographer, Region } from '../../BookingsCalendarTypes';

export type AllPhotographersResult = {
    photographers: Photographer[];
    availableRegions: Region[];
};

export class CalendarBookingApi {
    public static getAllPhotographers(): Promise<AllPhotographersResult> {
        return new Api().get('/views/photographer-booking/all-photographers');
    }
}
